module.exports = __webpack_public_path__ + "static/media/eg.e1ba2666.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/eg.svg
// module id = 818
// module chunks = 0